import { useEffect, useLayoutEffect, useRef, useState } from 'react'

import isEqual from 'lodash/isEqual'

export function useDeepEqualsMemoValue<T>(value: T) {
    const [memoizedValue, setMemoizedValue] = useState(value)
    const memoizedValueRef = useRef(memoizedValue)
    memoizedValueRef.current = memoizedValue

    const isMounted = useRef(false)
    useLayoutEffect(() => {
        isMounted.current = true
        return () => {
            isMounted.current = false
        }
    }, [])

    useEffect(() => {
        if (!isMounted.current) return
        if (isEqual(value, memoizedValueRef.current)) return

        setMemoizedValue(value)
        memoizedValueRef.current = value
    }, [value])

    return memoizedValue
}

export default useDeepEqualsMemoValue
